import React from 'react';
import Icon from '../../../components/AppIcon';
import { STAGE_LABELS } from '../utils/linkTokenFormat';

/**
 * Stage tab bar. Each tab shows one link category (stage); clicking it filters
 * the table to that stage. "All" clears the stage filter. Styling matches the
 * existing tab bar in vendor-approval-workflow (bottom-border tabs + count
 * badges) so it stays visually consistent.
 *
 * activeStage: the currently selected stage string, or null for "All".
 */
const TABS = [
  { key: 'ALL', stage: null, label: 'All', icon: 'List' },
  { key: 'REGISTRATION', stage: 'REGISTRATION', label: STAGE_LABELS.REGISTRATION, icon: 'UserPlus' },
  { key: 'RECTIFICATION', stage: 'RECTIFICATION', label: STAGE_LABELS.RECTIFICATION, icon: 'FileWarning' },
  { key: 'DOC_REPLACEMENT', stage: 'DOC_REPLACEMENT', label: STAGE_LABELS.DOC_REPLACEMENT, icon: 'Files' },
  { key: 'ACKNOWLEDGEMENT', stage: 'ACKNOWLEDGEMENT', label: STAGE_LABELS.ACKNOWLEDGEMENT, icon: 'ClipboardCheck' },
  { key: 'REGULARIZATION', stage: 'REGULARIZATION', label: STAGE_LABELS.REGULARIZATION, icon: 'RefreshCw' },
];

const StageTabs = ({ activeStage = null, counts = {}, total = 0, onChange }) => {
  const countFor = (stage) => (stage === null ? total : counts[stage] ?? 0);

  return (
    <div className="border-b border-slate-200">
      <nav className="flex px-6 overflow-x-auto">
        {TABS.map((tab) => {
          const active = activeStage === tab.stage;
          return (
            <button
              key={tab.key}
              onClick={() => onChange(tab.stage)}
              className={`flex items-center gap-2 px-6 py-4 border-b-2 font-semibold text-sm whitespace-nowrap transition-colors ${
                active
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-slate-600 hover:text-slate-900'
              }`}
            >
              <Icon name={tab.icon} size={18} />
              <span>{tab.label}</span>
              <span
                className={`ml-1 px-2 py-0.5 rounded-full text-xs font-medium ${
                  active ? 'bg-blue-600/10 text-blue-600' : 'bg-slate-100 text-slate-600'
                }`}
              >
                {countFor(tab.stage)}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default StageTabs;
